import initPhoneFormatter from '../phone-formatter';
import '../bootstrap';
import './loader';
import './main';
import './custom';
import '../country-selector';

import { LocationDataManager } from '../LocationDataManager';

const phoneSelecteur = "#phone, #telephone1, #telephone2, #phone_mobile, #mobilephone,#telephone_for_auth";

$(phoneSelecteur).on("input", function () {
    let val = $(this).val();

    // 1️⃣ Supprimer toutes les lettres
    val = val.replace(/[A-Za-z]/g, "");

    // 2️⃣ Supprimer les espaces au début et à la fin
    val = val.trim();

    // 3️⃣ Remplacer les multiples espaces consécutifs par un seul espace
    val = val.replace(/\s+/g, " ");

    $(this).val(val);
});

$(document).ready(function () {
  const locationDataManager = new LocationDataManager();
  // init phone formatter:
  initPhoneFormatter(
    phoneSelecteur,
    "#country",
  );
  
});

